"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableBlock = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/expandable-block.css");
/**
 * Container that allows content to be hidden behind a brief title and a caption.
 * @example
 * <ExpandableBlock title='Basic Block'>Content in block!</ExpandableBlock>
 * <ExpandableBlock title='Basic Block' caption='basic caption'>Content in block!</ExpandableBlock>
 * <ExpandableBlock title='Default Expanded Block' caption='basic caption' isExpanded={true}>Content in block!</ExpandableBlock>
 * <ExpandableBlock title='Positive status' status='positive'>Content</ExpandableBlock>
 * <ExpandableBlock title='Block with icon' endIcon={<SvgPlaceholder />}>Content</ExpandableBlock>
 */
const ExpandableBlock = (props) => {
    const { caption, children, className, title, onToggle, style, isExpanded = false, endIcon, status, size = 'default', styleType = 'default', ...rest } = props;
    (0, index_js_1.useTheme)();
    const icon = endIcon !== null && endIcon !== void 0 ? endIcon : (status && index_js_1.StatusIconMap[status]());
    const [expanded, setExpanded] = React.useState(isExpanded);
    React.useEffect(() => {
        setExpanded(isExpanded);
    }, [isExpanded]);
    const handleToggle = () => {
        setExpanded(!expanded);
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(!expanded);
    };
    const onKeyDown = (event) => {
        if (event.altKey) {
            return;
        }
        if (event.key === 'Enter' ||
            event.key === ' ' ||
            event.key === 'Spacebar') {
            handleToggle();
        }
    };
    return (React.createElement("div", { className: (0, classnames_1.default)('iui-expandable-block', {
            'iui-with-caption': !!caption,
            'iui-expanded': expanded,
            'iui-small': size === 'small',
            'iui-borderless': styleType === 'borderless',
        }, className), style: style, ...rest },
        React.createElement("div", { "aria-expanded": expanded, className: 'iui-header', tabIndex: 0, onClick: handleToggle, onKeyDown: onKeyDown },
            React.createElement(index_js_1.SvgChevronRight, { className: 'iui-icon', "aria-hidden": true }),
            React.createElement("span", { className: 'iui-expandable-block-label' },
                React.createElement("div", { className: 'iui-title' }, title),
                caption && React.createElement("div", { className: 'iui-caption' }, caption)),
            icon && React.createElement(index_js_1.Icon, { fill: status }, icon)),
        React.createElement(index_js_1.WithCSSTransition, { in: expanded },
            React.createElement("div", { className: 'iui-expandable-content' },
                React.createElement("div", null, children)))));
};
exports.ExpandableBlock = ExpandableBlock;
exports.default = exports.ExpandableBlock;
